import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Modal from '@/components/modal/Modal.tsx';
import ModalHeader from '@/components/modal/ModalHeader.tsx';
import ModalContent from '@/components/modal/ModalContent.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import useCreateCostCategory from '@/features/dashboard/costCategories/hooks/useCreateCostCategory.ts';
import {
  costCategorySchema,
  CostCategoryFormData,
  CostCategoryInputData,
  costCategoryDefaultValues,
} from '@/features/dashboard/costCategories/schemas/costCategorySchema.ts';
import CostCategoryForm from '@/features/dashboard/costCategories/components/CostCategoryForm.tsx';
import { getCostCategoryNameTakenMessage } from '@/features/dashboard/costCategories/api/costCategoryErrors.ts';

const CreateCostCategoryModal = ({ onClose }: { onClose: () => void }) => {
  const createMutation = useCreateCostCategory();

  const methods = useForm<CostCategoryInputData>({
    resolver: zodResolver(costCategorySchema),
    defaultValues: costCategoryDefaultValues,
  });

  const { handleSubmit, setError } = methods;

  const onSubmit = (data: CostCategoryFormData) => {
    createMutation.mutate(data, {
      onSuccess: () => onClose(),
      onError: (error) => {
        const message = getCostCategoryNameTakenMessage(error);
        if (message) setError('name', { message });
      },
    });
  };

  return (
    <Modal onClose={onClose} className="max-w-[520px]">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader title="Dodaj kategorię kosztów" onClose={onClose} />
          <ModalContent>
            <CostCategoryForm />
          </ModalContent>
          <ModalFooter>
            <ActionButton
              tone="ghost"
              size="sm"
              type="button"
              onClick={onClose}
            >
              Anuluj
            </ActionButton>
            <ActionButton
              tone="accent"
              size="sm"
              type="submit"
              isLoading={createMutation.isPending}
            >
              Dodaj
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default CreateCostCategoryModal;
